import { render, staticRenderFns } from "./WorkGuideAdd.vue?vue&type=template&id=4e33be41&scoped=true"
import script from "./WorkGuideAdd.vue?vue&type=script&lang=ts"
export * from "./WorkGuideAdd.vue?vue&type=script&lang=ts"
import style0 from "./WorkGuideAdd.vue?vue&type=style&index=0&id=4e33be41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e33be41",
  null
  
)

export default component.exports